export const NOTES_QUERY_KEY = 'notes';
